module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/ExtremelyHotDay/Kanagawa_ExtremelyHotDay_MRI_RCP85_End.png";